import { useContext } from "react";
import { RelayInfoContext } from "../contexts";

export const useRelayInfo = () => {
  const context = useContext(RelayInfoContext);

  if (context === undefined) {
    throw new Error("useRelayInfo must be used within a RelayInfoProvider");
  }
  return context;
};
